





































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetPatientCompletedTemplates } from "@/request/hdr";
import { GetDetailLeftNavDoneList } from "@/request/edr";
@Component({})
export default class HdrPatientDetailNav extends Vue {
  @Prop()
  private cState: any;
  @Prop()
  private patient: any;
  private cWrap: any = "";
  private zyyx: any[] = [];
  private doneTemplates: any[] = [];
  private loaded: boolean = false;
  @Watch("patient.patient_id", { immediate: true })
  private patientChange() {
    this.fetchShowNavList();
    if (this.patient.patient_id) {
      this.fetchDoneList();
    }
  }
  /**
   * @description 跳转
   */
  private goTo(part) {
    if (
      part["名称"] === "舌象数据-科研版" ||
      part["名称"] === "面象数据" ||
      part["名称"] === "脉象数据"
    ) {
      this.$router.replace({
        path: "/main/hdr/patient-detail",
        query: {
          patient_id: this.patient.patient_id,
          part: part["名称"],
          template_id: part["template_id"],
        },
      });
    } else {
      this.$router.replace({
        path: "/main/hdr/patient-detail",
        query: {
          patient_id: this.patient.patient_id,
          part,
        },
      });
    }
  }
  /**
   * @description 查询左侧可以展示哪些列表
   */
  private fetchShowNavList() {
    this.loaded = false;
    const params: any = {
      params: {
        patient_id: this.patient.patient_id,
      },
    };
    GetPatientCompletedTemplates(this, params).then((data: any) => {
      this.doneTemplates = data;
      this.loaded = true;
    });
  }
  /**
   * @description 判断某个量表是否需要显示
   */
  private ifShowTemplate(id) {
    let ifDisplay: boolean = false;
    this.doneTemplates.forEach((template: any) => {
      if (template.template_id === id) {
        ifDisplay = template.is_display;
      }
    });
    return ifDisplay;
  }
  /**
   * @description 切换开关
   */
  private triggerWrap(name) {
    this.cWrap = name;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (
      this.cState === "舌象数据-科研版" ||
      this.cState === "面象数据" ||
      this.cState === "脉象数据"
    ) {
      this.cWrap = "中医影像";
    } else if (
      this.cState === "中医体质" ||
      this.cState === "四诊合参" ||
      this.cState === "儿童版" ||
      this.cState === "老年版" ||
      this.cState === "备孕女性" ||
      this.cState === "孕期女性" ||
      this.cState === "产后女性" ||
      this.cState === "围绝经期女性"
    ) {
      this.cWrap = "体质辨识";
    } else if (this.cState === "高血压" || this.cState === "糖尿病") {
      this.cWrap = "慢病管理";
    }
  }
  /**
   * @description 检测当前用户
   */
  private fetchDoneList() {
    const params: any = {
      params: {
        patient_id: this.patient.patient_id,
      },
    };
    GetDetailLeftNavDoneList(this, params).then((data: any) => {
      console.log(data);
      this.zyyx = data;
    });
  }
}
